export enum FeatureFlag {
    SwapPIScreen = 'swappiscreen',
}
